// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"635cb632","145":"7660a7f1","174":"6991a03c","282":"568f9949","307":"c2bd2b3a","336":"701fea44","488":"8135b691","628":"0d4a0796","635":"92b332eb","641":"35e19b9c","672":"2081acbe","936":"d40efc1b","998":"04599ebe"}[chunkId] + ".css";
};